/** @file Handler table: one sampler per timeline kind (table-driven; no per-channel copies). */
import type { TimelineHandlers } from '../contracts/timeline';
import { channelHandler } from '../_internal/timeline/channelHandler';
import { colorHandler } from '../_internal/timeline/colorHandler';
import { deformHandler } from '../_internal/timeline/deformHandler';
import { discreteHandler } from '../_internal/timeline/discreteHandler';
import { drawOrderHandler } from '../_internal/timeline/drawOrderHandler';
import { eventHandler } from '../_internal/timeline/eventHandler';

const TABLE: TimelineHandlers = Object.freeze({
  rotation: channelHandler,
  x: channelHandler,
  y: channelHandler,
  scaleX: channelHandler,
  scaleY: channelHandler,
  shearX: channelHandler,
  shearY: channelHandler,
  alpha: channelHandler,
  ikMix: channelHandler,
  ikSoftness: channelHandler,
  ikBend: channelHandler,
  ikStretch: channelHandler,
  ikCompress: channelHandler,
  inherit: discreteHandler,
  attachment: discreteHandler,
  rgb: colorHandler,
  dark: colorHandler,
  deform: deformHandler,
  drawOrder: drawOrderHandler,
  event: eventHandler,
});

/** Samplers for every timeline kind (one shared, frozen table; calling it allocates nothing). */
export function timelineHandlers(): TimelineHandlers {
  return TABLE;
}
